import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, formatDate, useApi } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";

// Staff checklist built from the client's revision request: one task per «Da cambiare» (+ general notes), per round.
export function ReviewTasks({ siteId, version }) {
  const api = useApi();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState("");
  const base = `/sites/${siteId}/client-review/tasks`;
  const load = useCallback(() => api.get(base).then(({ data }) => setD(data)).catch((e) => toast.error(errMsg(e))), [api, base]);
  useEffect(() => { load(); }, [load, version]);
  if (!d?.tasks.length) return null;
  const toggle = async (t) => {
    setBusy(t.id);
    try { await api.post(`${base}/${t.id}`, { done: !t.done }); await load(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  return (
    <section className="space-y-1.5 rounded-md border border-slate-200 p-3" data-testid="review-tasks">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500" data-testid="review-tasks-count">
        Modifiche da fare · {d.open === 0 ? "tutte fatte" : `${d.open} ${d.open === 1 ? "aperta" : "aperte"}`} su {d.tasks.length}</p>
      <ul className="space-y-1">{d.tasks.map((t) => (
        <li key={t.id} className="flex items-start gap-2">
          <label className="flex min-h-10 min-w-0 flex-1 cursor-pointer items-start gap-2 py-1" data-testid={`review-task-${t.id}`}>
            <Checkbox className="mt-0.5 h-5 w-5" checked={t.done} disabled={busy === t.id} onCheckedChange={() => toggle(t)} data-testid={`review-task-check-${t.id}`} />
            <span className="min-w-0 flex-1 text-sm [overflow-wrap:anywhere]">
              <span className={t.done ? "text-slate-400 line-through" : "font-medium"}>{t.page ? `${t.page} › ` : ""}{t.label}</span>
              {t.note && <span className="block whitespace-pre-wrap break-words text-slate-600">{t.note}</span>}
              <span className="block text-xs text-slate-400">Giro {t.round}{t.done && t.done_at ? ` · fatta il ${formatDate(t.done_at, true)}${t.done_by ? ` da ${t.done_by}` : ""}` : ""}</span>
            </span>
          </label>
        </li>))}</ul>
    </section>);
}
